import { infiniteHits, configure } from 'instantsearch.js/es/widgets'
import { getInstance, registerWidget } from "./algolia-create-instance";
import { renderHitTemplate as fallbackTemplate } from "../../hits-templates/default-template"
import { preFilterHits } from './algolia-pre-filter.js';
import { __, _n, sprintf } from './i18n.js';

function initInfiniteHitsWidget() {
  const tgblAlgoliaDataJSON = window.atob(tgblAlgoliaDataEncoded);
  const tgblAlgoliaData = jQuery.parseJSON(tgblAlgoliaDataJSON);

  // Get all elements with infinite hits class
  // const elements = Array.from(document.getElementsByClassName("algolia-hits"));
  const elements = document.querySelectorAll("[data-filter-type='infinite-hits']")
  const elementsArray = Array.from(elements);

   // Group together refinement list elements that share an index
  const elementsGroupedByIndex = elementsArray.reduce((acc, element) => {
    const dataIndexValue = element.getAttribute("data-index");
    if (!acc[dataIndexValue]) {
      acc[dataIndexValue] = [];
    }
    acc[dataIndexValue].push(element);
    return acc;
  }, {});

  // Loop through each index
  for (const dataIndexValue in elementsGroupedByIndex) {
    if (elementsGroupedByIndex.hasOwnProperty(dataIndexValue)) {
      const elementsWithSameIndex = elementsGroupedByIndex[dataIndexValue];
      let search = getInstance(dataIndexValue);

      // Perform actions on elements with the same data-index value
      elementsWithSameIndex.forEach(async element => {

        const widgetID = element.getAttribute('data-id')
        const templatePath = tgblAlgoliaData[widgetID]['template_path'];
        const preFilterItemsObject = tgblAlgoliaData[widgetID]['pre_filter_items']
        const hitsPerPage = tgblAlgoliaData[widgetID]['hits_per_page']
       
        
        if(preFilterItemsObject) {
          let preFilterItems = Object.values(preFilterItemsObject);

          if(preFilterItems.length !== 0) {
            preFilterHits(preFilterItems, dataIndexValue);
          }
        } 

        let renderHitTemplate = fallbackTemplate
        
        if(templatePath) {
          try{
            const module = await import(templatePath)
            renderHitTemplate = module.default || module.renderHitTemplate
          } catch (error) {
            console.error(`Error loading template from ${templatePath}:`, error)
          }
        }

        let AlgoliaInfiniteHits = ($, search, element) => {
          search.addWidgets([
            configure({
              hitsPerPage: hitsPerPage
            }),
            infiniteHits({
              container: element,
              templates: {
                item: (hit, { html, component }) => {
                  // Inject i18n helpers alongside InstantSearch's own bindings (html, etc.)
                  // so templates can translate UI chrome via __()/_n()/sprintf().
                  const template = renderHitTemplate(hit, { html, component, __, _n, sprintf }, widgetID);
                  const event = new CustomEvent("algoliaRenderTenmplate", {});
                  window.dispatchEvent(event);
                  return template;
                },
              }
            })
          ]);
          registerWidget(element);
        };
        AlgoliaInfiniteHits($, search, element);
      });
    }
  }
}

export { initInfiniteHitsWidget }